import envConfig from './../config';


const get = (key) => envConfig[key];


export default {
    get
};
